export default import.meta.ROLLDOWN_FILE_URL_C$4kQWR6NkPB83QJdL0WCQ